<li class="menu-item-container">
    <!-- The label navigates; only the chevron expands a parent. Parents and `activeRoutes` items opt
         out of routerLinkActive: its prefix match would light up both `/campaign` siblings, and it
         would strip the class that isActive() sets. -->
    <a [routerLink]="item.route" [class.active]="item.route && isActive(item.route)"
        [class.has-active-child]="hasActiveChild()"
        [routerLinkActive]="item.isParent || item.activeRoutes ? [] : 'active'" class="menu-link">
        @if(item.icon) {
        <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
        }
        <span class="menu-label" matBadge="1" matBadgeOverlap="false" matBadgeSize="small"  [matBadgeHidden]="item.badgehidden">
            {{ item.label }}
        </span>

        @if(item.isParent && item.children) {
        <button type="button" class="expand-btn" [class.expanded]="item.expanded" (click)="toggleExpand($event)"
            [attr.aria-expanded]="!!item.expanded" [attr.aria-label]="(item.expanded ? 'Collapse ' : 'Expand ') + item.label">
            <mat-icon>expand_more</mat-icon>
        </button>
        }
    </a>

    @if(item.isParent && item.children) {
    <ul [class.expanded]="item.expanded" class="sub-menu">
        @for(childItem of item.children; track childItem) {
        <app-menu-item [item]="childItem"></app-menu-item>
        }
    </ul>
    }
</li>
